import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperItemDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    horizontal: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    vertical: {
        flexDirection: "column",
        alignItems: "stretch"
    },
    grow: {
        flexBasis: "auto",
        flexShrink: 1,
        flexGrow: 1
    },
    fixed: {
        flexShrink: 0,
        flexGrow: 0
    },
    container: {
        minWidth: 0
    }
});

export const useStyles = ({
    orientation,
    spaces
}: StepperItemDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(orientation === "horizontal") {
        styles.container.gap = spaces.spacingSm;
    }

    return styles;
};
export default stylesheet;
